const defaultConfig = {
    nativeBridge: {
        bridgeName: "AppCallbacks",
        androidBridgePath: "window.AppCallbacks",
        iosBridgePath: "window.webkit.messageHandlers",
    },
    webBridge: {
        bridgeName: "WebCallbacks",
    },
}

/**
 * sets the platform configuration for webviews
 * @param {object} [config] - platform config object
 */
const setPlatformConfig = (config) => {
    const platformConfig = Object.assign(defaultConfig, config)
    if (typeof window !== "undefined") {
        window.synapse = {}
        window.synapse.config = platformConfig
    }
    return platformConfig
}

module.exports = { setPlatformConfig, defaultConfig }
